/**
 * Presentation Layer - DataSeparationStatus Component
 * データ分離ステータス表示コンポーネント（シンプルChipベース）
 */

import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

/**
 * Props定義
 */
export interface DataSeparationStatusProps {
  /** 時間内データ件数 */
  inRangeCount: number;
  /** 時間外データ件数 */
  outOfRangeCount: number;
  /** 時間範囲の説明テキスト */
  timeRangeDescription?: string;
  /** 処理中フラグ */
  isProcessing?: boolean;
}

/**
 * データ分離ステータス表示コンポーネント
 */
export const DataSeparationStatus: React.FC<DataSeparationStatusProps> = ({
  inRangeCount,
  outOfRangeCount,
  timeRangeDescription,
  isProcessing = false,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
      <Chip
        label={`時間内データ: ${inRangeCount}件`}
        color="primary"
      />
      {outOfRangeCount > 0 && (
        <Chip
          label={`時間外データ: ${outOfRangeCount}件`}
          color="warning"
        />
      )}
      {timeRangeDescription && (
        <Typography variant="body2" sx={{ width: '100%', mt: 1 }}>
          時間範囲: {timeRangeDescription}
        </Typography>
      )}
    </Box>
  );
};
